import { render, staticRenderFns } from "./CompareBreadCrumbs.vue?vue&type=template&id=32a81e34&scoped=true&"
import script from "./CompareBreadCrumbs.vue?vue&type=script&lang=ts&"
export * from "./CompareBreadCrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a81e34",
  null
  
)

export default component.exports